import {
  bootstrapLoader,
  findOwnScriptSrc,
  loadConfigAndInject,
  parseWriteKeyFromScript,
} from "./entry.js";

export interface AutoInput {
  scriptSrc?: string | null;
  fetchFn?: typeof fetch;
}

export async function runAutoBootstrap(input: AutoInput = {}): Promise<void> {
  const src = input.scriptSrc ?? findOwnScriptSrc();
  if (!src) return;
  const writeKey = parseWriteKeyFromScript(src);
  if (!writeKey) return;
  bootstrapLoader({ writeKey, scriptSrc: src });

  // Idempotency guard: if the bundle script is already injected
  // (e.g. loader script included twice via GTM + manual snippet),
  // skip the second fetch+inject pass to avoid duplicate execution.
  if (document.querySelector("script[data-ets-bundle]")) return;

  // URL is known-valid here (parseWriteKeyFromScript already parsed it).
  const u = new URL(src);
  const configBaseUrl = `${u.protocol}//${u.host}`;
  await loadConfigAndInject({ writeKey, configBaseUrl, fetchFn: input.fetchFn });
}
